import React, { createContext, useContext, useState, useCallback } from 'react';

const ServerErrorContext = createContext();

export const ServerErrorProvider = ({ children }) => {
  const [isServerError, setIsServerError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const showServerError = useCallback((message = '') => {
    setErrorMessage(message);
    setIsServerError(true);
  }, []);

  const clearServerError = useCallback(() => {
    setIsServerError(false);
    setErrorMessage('');
  }, []);

  return (
    <ServerErrorContext.Provider
      value={{
        isServerError,
        errorMessage,
        showServerError,
        clearServerError,
      }}
    >
      {children}
    </ServerErrorContext.Provider>
  );
};

export const useServerError = () => {
  const context = useContext(ServerErrorContext);
  if (!context) {
    throw new Error('useServerError must be used within ServerErrorProvider');
  }
  return context;
};

